// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2e90355","453":"543b9334","732":"4f452f7a","977":"15bf2151"}[chunkId] + ".chunk.js";
};